import React from 'react';
import logo from '../imgs/logos/Logo gobierno colombia.jpeg';
import '../styles/LogoGobierno.css';

export default function LogoGobierno() {
    return (
        <div className='logo-gobierno__div--container'>
            <img src={logo} alt='logo-gobierno.jpeg'/>
        </div>
    )
}
